import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "service-documentation-item",
  templateUrl: "service-documentation.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class ServiceDocumentationItem {
  protected url = input.required<string>();
}
